<div class="scapi-wrapper" [ngClass]="{'has-navbar-fixed-bottom': assignment.plotIds.length > 0}"
  (click)="hideSelectableFields()">

  <div class="message is-fullwidth">

    <div class="message-header" (click)="toggleMinimizeFilters()" (dblclick)="toggleMinimizeFilters()">
      <p i18n>Filters</p>
      <div class="flex-spacer"></div>
      <p i18n>Page size</p>
      <input class="input input-pagesize" type="number" [(ngModel)]="pageSize" (keydown)="setPageSize($event)" (dblclick)="preventDefault($event)" (click)="preventDefault($event)" placeholder="Text input">
      <button class="btn-toggle-minimize">
        <span class="icon is-small">
          @if (!filtersMinimized) {
            <i-feather name="chevron-up"></i-feather>
          } @else {
            <i-feather name="chevron-down"></i-feather>
          }
        </span>
      </button>
    </div>

    @if (!filtersMinimized) {
      <div class="message-body">
        <div class="is-flex is-flex-direction-row is-flex-wrap-wrap filter-row unisized-labels" style="margin-bottom: 10px">
          <div class="label label-select">
            <span i18n>NCode-D</span>@if (filters.ncode.code.length > 0) {
            <span>
            ({{ filters.ncode.code.length }})</span>
          }
          @if ((nCodes$ | async); as nCodes) {
            <app-combo-select [options]="nCodes"
              [labelAttr]="['code', 'codeLabel']" valueAttr="code" [(ngModel)]="filters.ncode.code"/>
          }
        </div>
        <div class="label label-select">
          <span i18n>NCode-M</span>@if (filters.assessmentScapi.nCodeMeasured.length > 0) {
          <span>
          ({{ filters.assessmentScapi.nCodeMeasured.length }})</span>
        }
        @if ((nCodes$ | async); as nCodes) {
          <app-combo-select [options]="nCodes"
            [labelAttr]="['code', 'codeLabel']" valueAttr="code"
            [(ngModel)]="filters.assessmentScapi.nCodeMeasured"/>
        }
      </div>
      <div class="label label-select">
        <span i18n>Zone</span>@if (filters.eftasZones.length > 0) {
        <span> ({{ filters.eftasZones.length }})</span>
      }
      @if ((eftasZones$ | async); as zones) {
        <app-combo-select [options]="zones" [labelAttr]="['name']"
          valueAttr="name" [(ngModel)]="filters.eftasZones"/>
      }
    </div>
    <div class="label label-select">
      <span i18n>Class</span>@if (filters.ncode.classCode.length > 0) {
      <span>
      ({{ filters.ncode.classCode.length }})</span>
    }
    @if ((classes$ | async); as classes) {
      <app-combo-select [options]="classes"
        [labelAttr]="['code', 'label']" valueAttr="code" [(ngModel)]="filters.ncode.classCode"/>
    }
  </div>
  <div class="label label-select">
    <span i18n>On sFB task list</span>@if (filters.assignedSfbUsername.length > 0) {
    <span>
    ({{ filters.assignedSfbUsername.length }})</span>
  }

  @if (userGroups$ | async; as userGroups) {
    @if (userGroups.indexOf(sfbGroupName!) > -1) {
      <app-combo-select [options]="(operatorsSfb$ | async)" [labelAttr]="['username']" valueAttr="username"
          [(ngModel)]="filters.assignedSfbUsername"/>
      } @else {
        <app-combo-select [options]="[]" [labelAttr]="['username']" valueAttr="username"
          [(ngModel)]="filters.assignedSfbUsername"/>
      }
    }
  
</div>
<div class="label label-select">
  <div class="control">
    <ng-container i18n>On sCAPI</ng-container>&nbsp;
    <label class="radio">
      <input type="radio" name="scapi_operator_mode" value="task-list" style="margin-right: 3px"
        [(ngModel)]="scapiOperatorMode">
      <ng-container i18n>task list</ng-container>
    </label>
    &nbsp;
    <label class="radio">
      <input type="radio" name="scapi_operator_mode" value="watch-list" style="margin-right: 3px"
        [(ngModel)]="scapiOperatorMode">
      <ng-container i18n>watch list</ng-container>
    </label>
    @if (filters.assignedScapiUsername.length > 0) {
      <span>
      ({{ filters.assignedScapiUsername.length }})</span>
    }
  </div>
  @if (userGroups$ | async; as userGroups) {
    @if (userGroups.indexOf(scapiGroupName!) > -1) {
      <app-combo-select [options]="(operatorsScapi$ | async)" [labelAttr]="['username']" valueAttr="username"
      [ngModel]="filters.assignedScapiUsername"
      (ngModelChange)="setAssignedScapiUsername($event)"/>
  } @else {
    <app-combo-select [options]="[]" [labelAttr]="['username']" valueAttr="username"
      [(ngModel)]="filters.assignedScapiUsername"/>
  }
}
  
</div>
<div class="label label-select">
  <span i18n>Tags</span>@if (filters.assessmentScapi.tags.length > 0) {
  <span>
  ({{ filters.assessmentScapi.tags.length }})</span>
}
<div class="select is-fullwidth is-multiple">
  <select multiple [(ngModel)]="filters.assessmentScapi.tags" (change)='checkTagsCombination()'>
    @for (entry of tagTree; track entry) {
      <option class="tag-category" disabled>{{ entry.block }}</option>
      @for (tag of entry.tags; track tag) {
        <option [ngValue]="tag.name">&emsp;{{ tag.label }}</option>
      }
    }
  </select>
</div>
</div>
<div class="label label-select">
  <span i18n>Type of plot</span>@if (filters.ncode.category.length > 0) {
  <span>
  ({{ filters.ncode.category.length }})</span>
}
<div class="select is-fullwidth is-multiple">
  <select multiple [(ngModel)]="filters.ncode.category">
    @if (categories) {
      @for (category of categories; track category) {
        <option [ngValue]="category.id">{{ category.id }}
          : {{ category.label }}
        </option>
      }
    }
  </select>
</div>
</div>
<div class="label label-select">
  <span i18n>Monitor</span>@if (filters.results.monitor.length > 0) {
  <span>
  ({{ filters.results.monitor.length }})</span>
}
<div class="select is-fullwidth is-multiple">
  <select multiple [(ngModel)]="filters.results.monitor">
    @if ((monitors$ | async); as monitors) {
      @for (monitor of monitors; track monitor) {
        <option [ngValue]="monitor.name">{{ monitor.internalName }}</option>
      }
    }
  </select>
</div>
</div>
</div>
<div class="is-flex is-flex-direction-row is-flex-wrap-wrap filter-row checkbox-row" style="margin-bottom: 10px">
  <div class="label label-select" style="width: 300px">
    <ng-container i18n>Date of issue (from)</ng-container>
    <input class="input" type="date" [max]="today" [(ngModel)]="fromDateIssue">
  </div>
  <div class="label label-select" style="width: 300px">
    <ng-container i18n>Date of issue (to)</ng-container>
    <input class="input" type="date" [max]="today" [(ngModel)]="toDateIssue">
  </div>
  <div class="label label-select" style="width: 350px">
    <ng-container i18n>Object IDs</ng-container>
    <input class="input" type="text" [ngModel]="objectIDsString" (ngModelChange)="setObjectIDsString($event)">
  </div>
  <div class="label label-select is-flex is-flex-direction-column" style="width: 190px">
    <ng-container i18n>Status</ng-container>
    <div class="select">
      <select [(ngModel)]="selectState">
        <option [ngValue]="null"></option>
        <option [ngValue]="'new'">
          <ng-container i18n>new</ng-container>
        </option>
        <option [ngValue]="'in_progress'">
          <ng-container i18n>saved only</ng-container>
        </option>
        <option [ngValue]="'finished'">
          <ng-container i18n>finished</ng-container>
        </option>
      </select>
    </div>
  </div>
  <div class="label label-select is-flex is-flex-direction-column" style="width: 190px">
    <ng-container i18n>Selected for sFB</ng-container>
    <div class="select">
      <select [(ngModel)]="checkSfb">
        <option [ngValue]="null"></option>
        <option [ngValue]="true">
          <ng-container i18n>Yes</ng-container>
        </option>
        <option [ngValue]="false">
          <ng-container i18n>No</ng-container>
        </option>
      </select>
    </div>
  </div>
  <div class="label label-select is-flex is-flex-direction-column" style="width: 190px">
    <ng-container i18n>NCode-D &ne; NCode-M</ng-container>
    <div class="select">
      <select [(ngModel)]="checkNCodesMismatch">
        <option [ngValue]="null"></option>
        <option [ngValue]="true">
          <ng-container i18n>Yes</ng-container>
        </option>
        <option [ngValue]="false">
          <ng-container i18n>No</ng-container>
        </option>
      </select>
    </div>
  </div>
</div>
<div class="is-flex is-flex-direction-row is-flex-wrap-wrap filter-row checkbox-row"
  style="margin-bottom: 10px">
  <div class="label label-select" style="width: 300px">
    <ng-container i18n>Date of change (from)</ng-container>
    <input class="input" type="date" [max]="today" [(ngModel)]="fromDateChange">
  </div>
  <div class="label label-select" style="width: 300px">
    <ng-container i18n>Date of change (to)</ng-container>
    <input class="input" type="date" [max]="today" [(ngModel)]="toDateChange">
  </div>
  <div class="label label-select" style="width: 350px">
    <ng-container i18n>Result codes</ng-container>
    <input class="input" type="text" [ngModel]="resultCodesString"
      (ngModelChange)="setResultCodesString($event)">
  </div>
  <div class="label label-select is-flex is-flex-direction-column" style="width: 190px">
    <ng-container i18n>On-site photo requested</ng-container>
    <div class="select">
      <select [(ngModel)]="checkPhotoRequested">
        <option [ngValue]="null"></option>
        <option [ngValue]="true">
          <ng-container i18n>Yes</ng-container>
        </option>
        <option [ngValue]="false">
          <ng-container i18n>No</ng-container>
        </option>
      </select>
    </div>
  </div>
  <div class="label label-select is-flex is-flex-direction-column" style="width: 190px">
    <ng-container i18n>Photo available</ng-container>
    <div class="select">
      <select [(ngModel)]="checkPhoto">
        <option [ngValue]="null"></option>
        <option [ngValue]="true">
          <ng-container i18n>Yes</ng-container>
        </option>
        <option [ngValue]="false">
          <ng-container i18n>No</ng-container>
        </option>
      </select>
    </div>
  </div>
  
  
  <div class="label label-select" style="width: 350px">
    <div class="is-flex is-align-items-center">
      <ng-container i18n>Comments</ng-container>&nbsp;
      <span class="icon is-small is-right is-clickable" (click)="showCommentsInfo($event)"><i-feather
      name="help-circle" class="icon-smaller"></i-feather></span>
    </div>
    <input class="input" type="text" [(ngModel)]="filters.assessmentScapi.comment">
  </div>
</div>
<div class="buttons">
  @if (!loading) {
    <button class="button is-primary" (click)="requestPlots()">
      <strong i18n>Apply filters</strong>
    </button>
  } @else {
    <button class="button is-primary" disabled>
      <div class="loader"></div>&nbsp;
      <strong i18n>Apply filters</strong>
    </button>
  }
  <button class="button" (click)="resetFilters()" [disabled]="loading">
    <ng-container i18n>Reset filters</ng-container>
  </button>
</div>
</div>
}
</div>

@if (plots.length >= 1) {
  <div class="dropdown" [ngClass]="{'is-active': isFieldDropdownActive}">
    <div class="tags-wrapper">
      <div class="tags" (click)="showSelectableFields($event)">
        @for (field of selectedFields; track field) {
          <span class="tag is-rounded is-info is-light">
            {{ getFieldLabel(field) }}
            <button class="delete is-small" (click)="unselectField($event, field)"></button>
          </span>
        }
      </div>
    </div>
    <div class="dropdown-menu" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        @for (field of unselectedFields; track field) {
          <a class="dropdown-item" (click)="selectField(field)">
            {{ getFieldLabel(field) }}
          </a>
        }
      </div>
    </div>
  </div>
}

@if (plots.length >= 1) {
  <div class="table-container"
    [ngClass]="{'navbar-visible': plots.length >= 1}">
    <app-plot-list-multiple [plots]="plots" [selectedPlotIds]="assignment.plotIds" [fields]="selectedFields"
      [sortableColumns]="sortableFields" [showIndex]="true" (plotsSelected)="onPlotsSelected($event)"
    (scrolled)="onScrolled()" (requestSorting)="setSorting($event)"></app-plot-list-multiple>
  </div>
}


@if (plots.length >= 1) {
  <nav class="navbar is-fixed-bottom">
    <div class="navbar-start">
      @if (featuresCount > 0) {
        <div class="navbar-item">
          <div class="label">{{ featuresCount }}
            <ng-container i18n>Plots</ng-container>
          </div>
        </div>
      }
      @if (assignment.plotIds.length > 0) {
        <div class="navbar-item">
          <div class="label">{{ assignment.plotIds.length }}
            <ng-container i18n>selected</ng-container>
          </div>
        </div>
      }
      <div class="navbar-item">
        <div class="buttons">
          <button class="button" (click)="selectAll()">
            <ng-container i18n>Select all</ng-container>
          </button>
          <button class="button" (click)="selectNone()" [disabled]="assignment.plotIds.length === 0">
            <ng-container i18n>Select none</ng-container>
          </button>
          <button class="button" (click)="invertSelection()" [disabled]="assignment.plotIds.length === 0">
            <ng-container i18n>Invert selection</ng-container>
          </button>
          <button class="button" (click)="exportAsCSV()" [disabled]="assignment.plotIds.length === 0">
            <span class="icon">
              <i-feather name="download"></i-feather>
            </span>
            <span i18n>Export CSV</span>
          </button>
        </div>
      </div>
    </div>
    <div class="navbar-end">
      <div class="navbar-item">
        <div class="label" i18n>For</div>
      </div>
      <div class="navbar-item">
        <div class="select">
          <select [(ngModel)]="assignment.method">
            <option disabled selected [ngValue]="''"></option>
            <option value="sfb">sFB</option>
            <option value="scapi">SCAPI</option>
          </select>
        </div>
      </div>
      <div class="navbar-item">
        <div class="label" i18n>assign to</div>
      </div>
      <div class="navbar-item">
        <div class="select">
          <select [(ngModel)]="assignment.operator" [disabled]="!assignment.method">
            <option disabled selected [ngValue]="''"></option>
            @if (userGroups$ | async; as userGroups) {
              @if (assignment.method === 'sfb' && userGroups.indexOf(sfbGroupName!) > -1) {
                @for (operator of (operatorsSfb$ | async); track operator) {
                  <option [ngValue]="operator.username">
                    {{ operator.username }}
                  </option>
                }
              } @else {
                @if (assignment.method === 'scapi' && userGroups.indexOf(scapiGroupName!) > -1) {
                  @for (operator of (operatorsScapi$ | async); track operator) {
                    <option [ngValue]="operator.username">
                      {{ operator.username }}
                    </option>
                  }
                }
              }
            }
          </select>
        </div>
      </div>
      @if (assignment.method === 'sfb') {
        <div class="navbar-item">
          <input class="input" type="text" placeholder="Map index" i18n-placeholder>
        </div>
      }
      @if (assignment.method === 'scapi') {
        <div class="navbar-item">
          <div class="label" i18n>on</div>
        </div>
      }
      @if (assignment.method === 'scapi') {
        <div class="navbar-item">
          <div class="select">
            <select [(ngModel)]="assignment.target">
              <option value="task-list">
                <ng-container i18n>Task list</ng-container>
              </option>
              <option value="watch-list">
                <ng-container i18n>Watch list</ng-container>
              </option>
            </select>
          </div>
        </div>
      }
      <div class="navbar-item">
        <div class="buttons">
          <button class="button is-primary" [disabled]="!assignment.method || !assignment.operator"
            (click)="assignOperator()">
            <strong>OK</strong>
          </button>
        </div>
      </div>
    </div>
  </nav>
}
</div>
